const pad = (value) => String(value).padStart(2, '0');

const isSameLocalDay = (a, b) =>
  a.getFullYear() === b.getFullYear() &&
  a.getMonth() === b.getMonth() &&
  a.getDate() === b.getDate();

// Returns the epoch (ms) at which the quota resets, or null when the backend
// did not send a usable `retry_after_seconds`.
export const getResetAt = (retryAfterSeconds, now = Date.now()) => {
  if (
    typeof retryAfterSeconds !== 'number' ||
    !Number.isFinite(retryAfterSeconds) ||
    retryAfterSeconds <= 0
  ) {
    return null;
  }

  return now + retryAfterSeconds * 1000;
};

// Local time as HH:mm; the day and month are prepended when the reset falls on
// a different local day than `now`.
export const formatResetTime = (
  resetAt,
  now = Date.now(),
  language = 'es',
) => {
  const reset = new Date(resetAt);
  const time = `${pad(reset.getHours())}:${pad(reset.getMinutes())}`;

  if (isSameLocalDay(reset, new Date(now))) return time;

  const date = reset.toLocaleDateString(language, {
    day: 'numeric',
    month: 'short',
  });

  return `${date}, ${time}`;
};
